import { Link } from "react-router-dom";
import { Instagram } from "lucide-react";
import { LogoWordmark } from "./Logo";
import { useShop } from "@/context/ShopContext";

export default function Footer() {
  const { settings } = useShop();
  const year = new Date().getFullYear();

  return (
    <footer className="bg-[#050505] gold-hairline-t relative grain" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16 py-16 sm:py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-5 space-y-6">
            <LogoWordmark />
            <p className="font-sans-body text-sm text-[#B8B8B8] leading-relaxed max-w-sm font-light">
              An independent fragrance house devoted to personal expression, confidence,
              and scents that linger long after the moment has passed.
            </p>
            <a
              href={settings?.instagram_url || "https://www.instagram.com/kubwalofragrances/"}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 text-[#C6A15B] hover:text-[#D4AF37] transition-colors font-sans-body text-xs uppercase tracking-[0.25em]"
              data-testid="footer-instagram-link"
            >
              <Instagram size={16} strokeWidth={1.5} />
              {settings?.instagram_handle || "@kubwalofragrances"}
            </a>
          </div>

          <div className="md:col-span-2">
            <h4 className="eyebrow mb-6">Shop</h4>
            <ul className="space-y-3 font-sans-body text-sm text-[#B8B8B8]">
              <li><Link to="/shop" className="hover:text-[#D4AF37] transition-colors" data-testid="footer-shop-all">Shop All</Link></li>
              <li><Link to="/shop?category=mens" className="hover:text-[#D4AF37] transition-colors" data-testid="footer-shop-mens">Men's Fragrances</Link></li>
              <li><Link to="/shop?category=womens" className="hover:text-[#D4AF37] transition-colors" data-testid="footer-shop-womens">Women's Fragrances</Link></li>
              <li><Link to="/shop?category=unisex" className="hover:text-[#D4AF37] transition-colors" data-testid="footer-shop-unisex">Unisex Fragrances</Link></li>
              <li><Link to="/shop?format=rollon" className="hover:text-[#D4AF37] transition-colors" data-testid="footer-shop-rollons">Roll-On Collection — $10</Link></li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <h4 className="eyebrow mb-6">House</h4>
            <ul className="space-y-3 font-sans-body text-sm text-[#B8B8B8]">
              <li><Link to="/about" className="hover:text-[#D4AF37] transition-colors" data-testid="footer-about">About Us</Link></li>
              <li><Link to="/reviews" className="hover:text-[#D4AF37] transition-colors" data-testid="footer-reviews">Reviews</Link></li>
              <li><Link to="/contact" className="hover:text-[#D4AF37] transition-colors" data-testid="footer-contact">Contact Us</Link></li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <h4 className="eyebrow mb-6">Customer Care</h4>
            <ul className="space-y-3 font-sans-body text-sm text-[#B8B8B8]">
              <li><Link to="/policies/shipping" className="hover:text-[#D4AF37] transition-colors" data-testid="footer-shipping-policy">Shipping Policy</Link></li>
              <li><Link to="/track-order" className="hover:text-[#D4AF37] transition-colors" data-testid="footer-track-order">Track Your Order</Link></li>
              <li><Link to="/policies/returns" className="hover:text-[#D4AF37] transition-colors" data-testid="footer-returns-policy">Returns &amp; Refunds</Link></li>
              <li><Link to="/policies/privacy" className="hover:text-[#D4AF37] transition-colors" data-testid="footer-privacy-policy">Privacy Policy</Link></li>
              <li><Link to="/policies/terms" className="hover:text-[#D4AF37] transition-colors" data-testid="footer-terms">Terms &amp; Conditions</Link></li>
            </ul>
            {settings?.contact_email && (
              <p className="mt-6 font-sans-body text-sm text-[#B8B8B8]">
                <a href={`mailto:${settings.contact_email}`} className="hover:text-[#D4AF37] transition-colors" data-testid="footer-contact-email">
                  {settings.contact_email}
                </a>
              </p>
            )}
          </div>
        </div>

        <div className="mt-16 pt-8 gold-hairline-t flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="font-sans-body text-xs text-[#666666] tracking-wider" data-testid="footer-copyright">
            &copy; {year} Kubwalo Fragrances. All rights reserved.
          </p>
          <p className="font-sans-body text-[10px] uppercase tracking-[0.35em] text-[#666666]">
            Leave a lasting impression
          </p>
        </div>
      </div>
    </footer>
  );
}
